module.exports = __webpack_public_path__ + "media/images/sp/top/confetti-3dacc79c714cdb7a63c216c05c9e0a1d.png";